import * as React from 'react';

const Music = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M13.4728 3.02557C12.8467 2.88247 12.25 3.3582 12.25 4.00043V15.809C11.594 15.2995 10.7699 14.9961 9.875 14.9961C7.7349 14.9961 6 16.731 6 18.8711C6 21.0112 7.7349 22.7461 9.875 22.7461C12.0151 22.7461 13.75 21.0112 13.75 18.8711V7.83893L19.7772 9.21657C20.4033 9.35968 21 8.88394 21 8.24171V5.54329C21 5.07685 20.6775 4.67237 20.2228 4.56843L13.4728 3.02557Z"
      fill="#D1D1D1"
    />
  </svg>
);
export default Music;
